export const loadSalesforceScript = (salesforceScriptSrc: string) => {
  if (window.embeddedservice_bootstrap || !salesforceScriptSrc) {
    return
  }

  const script = document.createElement('script')
  script.setAttribute('src', salesforceScriptSrc)
  script.setAttribute('type', 'text/javascript')

  script.onload = () => {
    window.embeddedservice_bootstrap.settings.language = 'en_US'
  }

  // TODO: if this fail, we should show the chat widget but display fallback page (waiting for design)
  // https://acorns.atlassian.net/browse/AI-633
  // script.onerror = () => {
  // }

  document.head.appendChild(script)
}

type HiddenPrechatFields = {
  firstName: string
  lastName: string
  email: string
  deviceId: string
  context: string
  chatSessionId: string
  supportCategory: string
}

export const initializeSalesforceWidget = async ({
  hiddenPrechatFields,
  salesforceBaseLiveAgentUrl,
  salesforceOrgId,
  salesforceScrt2Url,
  setIsSalesforceWidgetInitialized,
  setShowFallbackModal,
}: {
  setIsSalesforceWidgetInitialized: (
    isSalesforceWidgetInitialized: boolean,
  ) => void
  salesforceOrgId: string
  salesforceBaseLiveAgentUrl: string
  salesforceScrt2Url: string
  setShowFallbackModal: (showFallbackModal: boolean) => void
  hiddenPrechatFields: HiddenPrechatFields
}) => {
  window.addEventListener('onEmbeddedMessagingReady', async () => {
    window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
      AI_Chat_User_Question: hiddenPrechatFields.context,
      Device_ID: hiddenPrechatFields.deviceId,
      Email: hiddenPrechatFields.email,
      First_Name: hiddenPrechatFields.firstName,
      Last_Name: hiddenPrechatFields.lastName,
      Chat_Session_ID: hiddenPrechatFields.chatSessionId,
      Support_Category: hiddenPrechatFields.supportCategory,
    })
  })

  try {
    await window.embeddedservice_bootstrap.init(
      salesforceOrgId,
      'Acorns_Web_Messaging',
      salesforceBaseLiveAgentUrl,
      {
        scrt2URL: salesforceScrt2Url,
      },
    )

    setIsSalesforceWidgetInitialized(true)
    autoLaunchChatWithRetry()
    window.addEventListener('onEmbeddedMessagingConversationClosed', () => {
      window.embeddedservice_bootstrap?.userVerificationAPI
        ?.clearSession(true)
        ?.finally(() => {
          window.embeddedservice_bootstrap?.utilAPI?.removeAllComponents()
          setIsSalesforceWidgetInitialized(false)
        })
    })
  } catch (error) {
    setShowFallbackModal(true)
  }
}

const MAX_RETRIES = 3
const RETRY_DELAY_MS = 1000

const autoLaunchChatWithRetry = (): Promise<boolean> => {
  return new Promise((resolve) => {
    let attempts = 0

    const attemptLaunch = () => {
      attempts += 1

      if (window.embeddedservice_bootstrap?.utilAPI?.launchChat) {
        try {
          window.embeddedservice_bootstrap.utilAPI.launchChat()

          resolve(true)
          return
        } catch (error) {
          resolve(false)
        }
      }

      if (attempts < MAX_RETRIES) {
        setTimeout(attemptLaunch, RETRY_DELAY_MS)
      }
    }

    attemptLaunch()
  })
}
